export default "__VITE_ASSET__DSqBXIY9__"